import React, { forwardRef } from 'react';
import InputMask from 'react-input-mask';

const CustomInputLabelExterno = forwardRef(({ inputName = null, onChange = null, placeholder = "", title = "", value = "", id = null, onClick = null, label, readOnly = false, disabled = null, className = "" }, ref) => (
    <div className="form-group">
        <label htmlFor="floatingInput">{label}</label>
        <InputMask
            disabled={disabled}
            ref={ref}
            title={title}
            mask="99/99/9999"
            readOnly={readOnly}
            type="text"
            className={`form-control ${className}`}
            name={inputName}
            onChange={onChange}
            value={value}
            id={id}
            onClick={onClick}
        />
    </div>
));

export default CustomInputLabelExterno;
